export default __webpack_public_path__ + "static/media/monkey-business.2fe25af8.png";